<template>
  <section id="Items" v-if="item.quantity !== 0">
    <div class="container-md">
      <div class="row">
        <div class="col-12">
          <h2 class="p-4" :class="sType === '5' ? 'lab-grown' : 'real-diamond'">
            {{ $t("Item.headline") }}
          </h2>
        </div>
      </div>
      <div class="row" v-if="item.quantity !== 0">
        <Carousel v-bind="carouselConfig">
          <Slide v-for="(item, index) in item.list" v-bind:key="index">
            <div class="carousel__item">
              <a :href="configuratorUrl + item.itemnumber + ':54'">
                <img
                  :src="
                    apiUrl +
                    '/v2/images/item/ffffff/200/200/' +
                    item.itemnumber +
                    '.jpg'
                  "
                  class=""
                  width="200"
                  height="200"
                />
                <p class="carousel__caption text-center">
                  {{ $n(item.price, "currency") }}
                </p>
              </a>
            </div>
          </Slide>
          <template #addons>
            <CarouselNavigation />
            <CarouselPagination v-bind="paginationConf" />
          </template>
        </Carousel>
      </div>
    </div>
  </section>
  <Loader v-if="loading === true && item.quantity === 0" />
</template>
<script>
import "vue3-carousel/carousel.css";
import DAOItems from "@/assets/DAO/Items";
import DAODiamond from "@/assets/DAO/Diamond";
import Logger from "@/assets/Helper/Logger";
import Loader from "@/components/SpinnerLoader";

import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { onMounted, ref, reactive, computed, watchEffect } from "vue";
import {
  Carousel,
  Slide,
  Navigation as CarouselNavigation,
  Pagination as CarouselPagination,
} from "vue3-carousel";

export default {
  name: "item-list",
  components: {
    Loader,
    Carousel,
    Slide,
    CarouselNavigation,
    CarouselPagination,
  },
  props: {
    diamondId: {
      required: true,
    },
    stoneType: {
      required: true,
    },
  },
  setup: function (props) {
    const router = useRouter();
    const store = useStore();
    const appUrl = store.getters["config/getAppUrl"];
    const apiUrl = store.getters["config/getApiHostWithLocalStr"];
    const id = ref(props.diamondId);
    const sType = ref(props.stoneType);
    const loading = ref(true);
    const item = reactive({
      quantity: ref(0),
      list: ref({}),
    });
    const paginationConf = ref({
      paginateByItemsToShow: true,
    });
    const carouselConfig = ref({
      gap: 5,
      height: 200,
      mouseDrag: true,
      wrapAround: true,
      snapAlign: "center",
      breakpoints: {
        300: {
          itemsToScroll: 1,
          itemsToShow: 1.7,
          snapAlign: "center",
        },
        380: {
          itemsToScroll: 1,
          itemsToShow: 1.9,
          snapAlign: "center",
        },
        420: {
          itemsToScroll: 1,
          itemsToShow: 2,
          snapAlign: "center",
        },
        470: {
          itemsToScroll: 1,
          itemsToShow: 2.25,
          snapAlign: "center",
        },
        530: {
          itemsToScroll: 1,
          itemsToShow: 2.5,
          snapAlign: "center",
        },
        600: {
          itemsToScroll: 1,
          itemsToShow: 2.8,
          snapAlign: "center",
        },
        660: {
          itemsToScroll: 3,
          itemsToShow: 3.1,
          snapAlign: "center",
        },
        768: {
          itemsToScroll: 3,
          itemsToShow: 3.35,
          snapAlign: "center",
        },
        992: {
          itemsToScroll: 3,
          itemsToShow: 4.25,
          snapAlign: "center",
        },
        1200: {
          itemsToScroll: 5,
          itemsToShow: 5.35,
          snapAlign: "center",
        },
      },
    });
    async function getItems(catalogId) {
      const basicItems = await getBasicItems(catalogId);
      if (basicItems !== false) {
        await addDiamondToItems(basicItems);
      } else {
        loading.value = false;
      }
    }

    async function getBasicItems(catalogId) {
      try {
        return DAOItems.getBasicCatalogItems(catalogId, sType.value);
      } catch (error) {
        Logger.debug("Fehler beim Katalogaufruf: ", error);
        return false;
      }
    }

    async function addDiamondToItems(basicItems) {
      DAODiamond.addToItems(id.value, basicItems).then(
        (response) => {
          if (
            typeof response === "object" &&
            Object.keys(response).length > 0
          ) {
            item.quantity = Object.keys(response).length;
            item.list = response;
          }
        },
        (alerts) => {
          loading.value = false;

          if (typeof alerts == "object" && alerts.length > 0) {
            Logger.debug("Alerts", alerts);

            for (let key in alerts) {
              Notification.create(alerts[key].title, alerts[key].text);
            }
          } else {
            Logger.debug("No alerts set", alerts);
          }
        }
      );
    }

    watchEffect(() => {
      if (item.quantity > 0) {
        loading.value = false;
      }
    });

    onMounted(() => {
      getItems(25754);
    });

    return {
      appUrl,
      apiUrl,
      router,
      id,
      sType,
      item,
      loading,
      carouselConfig,
      paginationConf,
      configuratorUrl: computed(() => {
        return typeof window.diamondStockConfig.configuratorUrl === "string" &&
          window.diamondStockConfig.configuratorUrl !== ""
          ? window.diamondStockConfig.configuratorUrl
          : "/";
      }),
    };
  },
};
</script>

<style lang="scss" scoped>
#Items {
  margin: 4rem 0 2rem;
  background: #f0f0f0;

  .btn {
    line-height: 1.6rem;
    margin-bottom: 1.5rem;

    &.btn-real-diamond-stock {
      &:not(.collapsed) {
        color: $fontColor;
        background: #fff;
        border-color: $realDiamondColor;
      }
    }

    &.btn-lab-grown {
      &:not(.collapsed) {
        color: $fontColor;
        background: #fff;
        border-color: $labGrownColor;
      }
    }
  }

  .carousel {
    margin-bottom: 2rem;

    .carousel__slide {
      .carousel__item {
        width: 20rem;
        height: 20rem;
        background: #fff;
        position: relative;
        a {
          text-decoration: none;

          img {
            width: 100%;
            height: auto;
            max-width: 20rem;
          }

          .carousel__caption {
            bottom: 0;
            width: 100%;
            margin: 0 auto;
            color: $fontColor;
            font-size: 1.6rem;
            font-weight: bold;
            position: absolute;
            padding: 0.25rem 0.76rem;
          }
        }
      }
    }

    .carousel__pagination {
      bottom: -1.25rem;

      @media (max-width: 474px) {
        display: none;
      }
    }
  }
}
</style>
